@if (updateService.updateAvailable$ | async) {
<div class="update-banner" role="alert" aria-live="polite">
    <div class="update-banner__content">
        <div class="update-banner__left">
            <span class="update-banner__dot"></span>
            <i class="pi pi-refresh update-banner__icon"></i>
            <span class="update-banner__text">
                <strong>Nueva versión disponible</strong>
                <span class="update-banner__sub">Actualiza para obtener las últimas mejoras.</span>
            </span>
        </div>
        <div class="update-banner__actions">
            <button class="update-banner__btn update-banner__btn--secondary" (click)="updateService.dismissUpdate()"
                aria-label="Cerrar notificación">
                Ahora no
            </button>
            <button class="update-banner__btn update-banner__btn--primary" (click)="updateService.applyUpdate()"
                aria-label="Actualizar aplicación">
                <i class="pi pi-download"></i>
                Actualizar ahora
            </button>
        </div>
    </div>
</div>
}